import { Form, InputStyled } from "./style";
import { Box, Button, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { IProps, filters } from "./models";
import { useEffect, useState } from "react";
import moment from "moment";

type FilterFormState = {
  dataInicial: string | Date;
  dataFinal: string | Date;
  [key: string]: any;
};

export const FilterForm = (props: IProps) => {
  const [form, setForm] = useState<FilterFormState>({
    ...filters,
  });
  const [error, setError] = useState({ ...filters });

  useEffect(() => {
    // Converte as datas do formato YYYY-MM-DD para Date objects
    const formattedFilter = {
      ...props.dataFilter,
      dataInicial: props.dataFilter.dataInicial
        ? moment(props.dataFilter.dataInicial).toDate()
        : "",
      dataFinal: props.dataFilter.dataFinal
        ? moment(props.dataFilter.dataFinal).toDate()
        : "",
    };
    setForm(formattedFilter);
  }, [props.dataFilter]);

  const handleChange = (event: any) => {
    setForm({ ...form, [event.target.name]: event.target.value });
  };

  const handleChangeDateInit = (date: any) => {
    if (date && !isNaN(date.getTime())) {
      setForm({
        ...form,
        dataInicial: date,
      });
    }
  };

  const handleChangeDateEnd = (date: any) => {
    if (date && !isNaN(date.getTime())) {
      setForm({
        ...form,
        dataFinal: date,
      });
    }
  };

  const saveFilter = () => {
    if (validDates()) {
      const dataInicial =
        form.dataInicial !== "" && form.dataInicial
          ? moment(form.dataInicial).format("YYYY-MM-DD")
          : "";
      const dataFinal =
        form.dataFinal !== "" && form.dataFinal
          ? moment(form.dataFinal).format("YYYY-MM-DD")
          : "";

      props.onSave({
        ...form,
        dataInicial,
        dataFinal,
      });
    }
  };

  const clearForm = () => {
    const clearedForm = { ...filters };
    setForm(clearedForm);
    setError({ ...filters });
    props.onSave(clearedForm);
  };

  const validDates = () => {
    const newError = { ...filters };
    let isValid = true;

    // Validação: se há data final, deve haver data inicial
    if (!form.dataInicial && form.dataFinal) {
      newError.dataInicial = "Data Inicial Obrigatória.";
      isValid = false;
    }

    // Validação: se há data inicial, deve haver data final
    if (form.dataInicial && !form.dataFinal) {
      newError.dataFinal = "Data Final Obrigatória.";
      isValid = false;
    }

    // Validação: data final deve ser posterior à data inicial
    if (form.dataInicial && form.dataFinal) {
      const dataInicial = moment(form.dataInicial);
      const dataFinal = moment(form.dataFinal);

      if (dataFinal.isBefore(dataInicial)) {
        newError.dataFinal = "Data Final deve ser posterior à Data Inicial.";
        isValid = false;
      }
    }

    setError(newError);
    return isValid;
  };

  const formatDateValue = (date: any) => {
    if (!date) return null;

    // Se já é um Date object válido, retorna
    if (date instanceof Date && !isNaN(date.getTime())) {
      return date;
    }

    // Se é uma string no formato ISO, converte para Date
    if (typeof date === "string" && moment(date).isValid()) {
      return moment(date).toDate();
    }

    // Se é uma string no formato dd/MM/yyyy, converte
    if (typeof date === "string" && date.includes("/")) {
      const parts = date.split("/");
      if (parts.length === 3) {
        const formatted = `${parts[2]}-${parts[1]}-${parts[0]}`;
        return moment(formatted).toDate();
      }
    }

    return null;
  };

  return (
    <Box>
      <Form>
        <Box width={"100%"} display="flex" gap={2}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Box flex={1}>
              <DatePicker
                label="Data Inicial"
                inputFormat="dd/MM/yyyy"
                value={formatDateValue(form.dataInicial)}
                onChange={handleChangeDateInit}
                minDate={new Date("2000-01-01")}
                maxDate={new Date("2999-12-31")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!error.dataInicial}
                    helperText={error.dataInicial || " "}
                  />
                )}
              />
            </Box>
            <Box flex={1}>
              <DatePicker
                label="Data Final"
                inputFormat="dd/MM/yyyy"
                value={formatDateValue(form.dataFinal)}
                onChange={handleChangeDateEnd}
                minDate={new Date("2000-01-01")}
                maxDate={new Date("2999-12-31")}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!error.dataFinal}
                    helperText={error.dataFinal || " "}
                  />
                )}
              />
            </Box>
          </LocalizationProvider>
        </Box>
      </Form>
      <Box
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "20px",
          gap: "16px",
        }}
      >
        <Button
          sx={{
            width: "140px",
          }}
          color="secondary"
          variant="outlined"
          onClick={clearForm}
        >
          Limpar
        </Button>
        <Button
          sx={{
            width: "140px",
          }}
          color="primary"
          variant="contained"
          onClick={saveFilter}
        >
          Salvar Filtro
        </Button>
      </Box>
    </Box>
  );
};
